import React from 'react';
import MetricaBase from './MetricaBase';

const MetricaGeneros = () => {
  return (
    <MetricaBase
      titulo="Distribuição por Gênero"
      descricao="Análise da distribuição de colaboradores ativos por gênero"
      endpoint="generos"
      tipoDownload="generos"
      cor="purple"
    />
  );
};

export default MetricaGeneros;